import Service from "../components/Service/Service";
import React, { Fragment } from "react";

const ServicePage = () => {
  return (
    <Fragment>
      <Service />
    </Fragment>
  );
};

export default ServicePage;
